import { bookOfMindRepository } from "motw_core/Repositories/BookOfMindRepository";
import * as React from "react";
import ClientDataProvider from "source/app/services/External/ClientDataProvider/ClientDataProvider";
import { SetBookOfMindState } from "../../Helpers/BookOfMindHelpers";

export function LoadAllBookOfMindQuotesChronologically(
    readingListNodeNames: string[]
) {
    React.useEffect(() => {
        let isCurrent = true;

        Promise.all(
            readingListNodeNames.map((nodeName) =>
                bookOfMindRepository.GetBookOfMindQuotesAsync(
                    ClientDataProvider,
                    nodeName
                )
            )
        ).then((quoteLists) => {
            if (isCurrent) {
                const chronologicalQuotes = quoteLists.flat();
                SetBookOfMindState({ chronologicalQuotes });
            }
        });

        return () => {
            isCurrent = false;
        };
    }, [readingListNodeNames.join("\u0000")]);
}
